<template>
  <div class="content-item">
    <a-row type="flex" align="middle" :class="'video-container ' + (videoStatus === 'review' ? 'under-review' : '')">
      <a-col :md="{ span: videoStatus === 'review' ? 22 : 11, offset: 1 }">
        <a-row :gutter="20" class="connect-to-church" v-if="videoStatus == 'review' && isConnectionVisible">
          <a-col>
            <div class="text-right">
              <a-button type="link" class="tf-text-primary" style="color: #ffb612 !important" @click="isViewExample = true">View Example</a-button>
            </div>
            <a-card :title="$t('cardTitle.connectToChurch')" class="style3 text-center">
              <template v-if="isConnected">
                <div>
                  <span style="margin-right: 2px; color: #212b36">Your request is waiting to be approved by {{ connectedChurchName }}!</span>
                  <br />
                  <a-button type="primary" class="tf-btn-primary" style="margin-top: 15px" @click="e => disconnectChurchConnection()"> Disconnect </a-button>
                </div>
              </template>
              <template v-else>
                <p style="text-align: left; font-size: 24px" v-if="isShowClickLink">
                  1. Look for your church using city, state or zip
                  <br />
                  2. Select "Connect" next to your church's name
                  <br />
                  3. <a style="color: #ffb612 !important; text-decoration: underline" @click="showChurchForm">Click here</a> if your church isn't listed if you don't have one skip this step.
                </p>
                <p v-else style="text-align: left">
                  Please provide us with your church information and we will connect with your pastor. If you don't know the information right away, please visit their website now and come back and
                  fill out the details listed below.
                </p>

                <div style="max-width: 720px; margin: 0 auto">
                  <a-input-search placeholder="City & State... or Zip Code..." enter-button="Search" size="large" @search="onSearch" v-if="isShowClickLink" />

                  <a-table
                    :columns="columns"
                    :data-source="churchList"
                    :showHeader="false"
                    :locale="{
                      emptyText: 'Unfortunately, Your church is not registered with TrueLife.org yet. \n\r Please enter your church contact information.',
                    }"
                    rowKey="id"
                    style="margin-top: 1rem"
                    class="no-attempts"
                  >
                    <a slot="name" slot-scope="text, record">
                      <span v-text="record.name" style="color: white" @click="e => fillForm(record)" />
                      <span v-text="` - ${record.city} ${record.state}`" />
                    </a>
                    <span slot="action" slot-scope="text, record">
                      <a-button type="primary tf-primary tf-btn-primary" style="min-width: 100px" @click="e => connectToChurch(record)"> Connect </a-button>
                    </span>
                  </a-table>
                  <br />
                  <a-form
                    v-if="isSubmitFormVisible"
                    :form="form"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 12 }"
                    :hideRequiredMark="true"
                    @submit="handleSubmit"
                    id="churchConnectForm"
                    style="margin-top: 2rem"
                  >
                    <a-form-item label="Church Name">
                      <a-input
                        v-decorator="[
                          'churchname',
                          {
                            rules: [{ required: true, message: 'Church Name can not blank!' }],
                          },
                        ]"
                        placeholder="Church Name"
                      />
                    </a-form-item>
                    <a-form-item label="Pastor Name">
                      <a-input
                        v-decorator="[
                          'pastorname',
                          {
                            rules: [{ required: true, message: 'Pastor Name can not blank!' }],
                          },
                        ]"
                        placeholder="Pastor Name"
                      />
                    </a-form-item>
                    <a-form-item label="Pastor Email">
                      <a-input
                        v-decorator="[
                          'pastoremail',
                          {
                            rules: [{ required: true, message: 'Pastor email can not blank!' }],
                          },
                        ]"
                        placeholder="Pastor Email"
                      />
                    </a-form-item>
                    <a-form-item label="Church Number">
                      <a-input v-decorator="['churchnumber']" placeholder="Church Number" />
                    </a-form-item>
                    <a-form-item label="Church Website">
                      <a-input v-decorator="['churchwebsite']" placeholder="Church Website" />
                    </a-form-item>
                    <a-form-item :wrapper-col="{ span: 24, offset: 0 }" :style="{ textAlign: 'center' }">
                      <a-spin tip="Sending connect request ..." :spinning="isConnecting" size="large">
                        <div class="spin-content">
                          <a-button type="primary" class="tf-btn tf-btn-primary" style="width: 180px" html-type="submit"> Submit </a-button>
                        </div>
                      </a-spin>
                    </a-form-item>
                  </a-form>
                </div>
                <p style="text-align: center" v-if="searchAttempt">
                  <a style="color: #1c84c6; text-decoration: underline" @click="showChurchForm">Click here if you don't see your church</a>
                </p>
              </template>

              <a-modal title="" centered :footer="null" :visible="isViewExample" :closable="false" :width="1024">
                <div style="text-align: center">
                  <a-row :gutter="20" style="margin-top: 2rem; margin-bottom: 2rem" v-if="videoStatus == 'review' && isIndividual">
                    <a-col :md="{ span: 20, offset: 2 }" :lg="{ span: 22, offset: 1 }">
                      <h3>
                        <strong>
                          Now that your video is under review we need you to connect your church, as you can see in the image provided. Please search for your church and if you do not see your church
                          provide us with the details so we can call your church and get them connected.
                        </strong>
                      </h3>
                    </a-col>
                    <a-col :md="{ span: 20, offset: 2 }" :lg="{ span: 22, offset: 1 }">
                      <img :src="require('../../assets/images/church_connect_thomasroad.jpg')" style="margin-top: 1rem; width: 100%" />
                    </a-col>
                  </a-row>
                  <a-button
                    type="primary"
                    @click="
                      e => {
                        isViewExample = false;
                      }
                    "
                  >
                    OK
                  </a-button>
                </div>
              </a-modal>
              <a-modal title="" centered :footer="null" :visible="isConnectionSent" :closable="false">
                <div style="text-align: center">
                  <p>
                    We have sent your connect request to <span style="color: #1c84c6">{{ selectedChurch.name }}</span> successfully. You will get emailed when the pastor approves or declines this
                    request.
                  </p>
                  <a-button
                    type="primary"
                    @click="
                      e => {
                        isConnectionSent = false;
                      }
                    "
                  >
                    OK
                  </a-button>
                </div>
              </a-modal>
              <a-modal title="" centered :footer="null" :visible="isCreationSent" :closable="false">
                <div style="text-align: center">
                  <p>
                    Thank you for the information. We have sent an email to your pastor and also emailed you an email to forward to your pastor. You can still use your Jesus Story while we are waiting
                    for your church to connect.
                    <br />
                    You will be notified once your Jesus Story is approved.
                    <br />
                    You are all done for now!
                  </p>
                  <a-button
                    type="primary"
                    @click="
                      e => {
                        isCreationSent = false;
                      }
                    "
                  >
                    OK
                  </a-button>
                </div>
              </a-modal>
              <a-modal title="" centered :footer="null" :visible="isMultiAttempt" :closable="false">
                <div style="text-align: center">
                  <p>
                    Your account is already connected to the church <span style="color: #1c84c6">{{ selectedChurch.name }}</span
                    >.
                  </p>
                  <a-button
                    type="primary"
                    @click="
                      e => {
                        isMultiAttempt = false;
                      }
                    "
                  >
                    OK
                  </a-button>
                </div>
              </a-modal>
            </a-card>
          </a-col>
        </a-row>
        <a-row type="flex" justify="space-between" style="margin-top: 30px">
          <a-col>
            <span class="status-tag" :class="videoStatus">
              <a-icon :type="videoStatusIcon" :style="{ fontSize: '24px', marginRight: '1rem' }" />
              {{ $t(`label.introVideoStatus.${videoStatus}`) }}
            </span>
          </a-col>
          <a-col>
            <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="$emit('onRedo')" v-if="videoStatus !== 'no_payment' && videoStatus !== 'review'">
              <a-button type="primary" class="action-button long tf-btn tf-btn-primary">
                <span>{{ $t('button.redoTypeVideo', { type: capitalize(type) }) }}</span>
              </a-button>
            </a-popconfirm>
          </a-col>
        </a-row>
        <a-row class="mt-3">
          <a-col>
            <div v-if="videoObject.video_type == 'external'" class="player-wrapper">
              <div :id="reviewPlayerId" class="review-video" />
            </div>
            <div v-if="videoObject.video_type == 'embed'" class="responsive-embed">
              <button
                class="thumbnail-bg"
                v-if="thumbnailVisible"
                @click="e => (thumbnailVisible = false)"
                :style="{ 'background-image': `url(${videoObject.video_thumbnail})`, 'background-size': '100% 100%' }"
              >
                <img src="resources/images/thumbnail-play.svg" class="thumbnail-play" />
              </button>
              <iframe
                :src="embedUrl"
                style="left: 0; top: 0; height: 100%; width: 100%; position: absolute"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
                :style="{ visibility: thumbnailVisible ? 'hidden' : 'visible' }"
              ></iframe>
            </div>

            <a-row type="flex" justify="space-between" style="padding: 4px 16px" v-if="videoStatus === 'approved'">
              <a-col>
                <!-- <span>{{ videoObject.total_views | shortNumber }} Views</span> -->
                <span>{{ videoObject.total_views }} Views</span>
              </a-col>
              <a-col>
                <span>{{ videoObject.created_at | timeAgo }}</span>
              </a-col>
            </a-row>
            <p class="mt-4 video-msg-review" v-if="videoStatus !== 'approved'">
              <template v-if="videoStatus === 'no_payment'"> The church has not made their payment to keep this welcome message active. </template>
              <template v-if="videoStatus === 'review' && isPastor">
                Thank you for your submission. The video is now in line to be reviewed. This process can take around 24 hours depending on the amount of submissions. You will be notified by email and
                here as well after a <br v-if="isDesktop" />decision <br v-if="!isDesktop" />has been made.
              </template>
              <template v-else-if="videoStatus === 'blocked'">
                Your video has been blocked for the following reason: <br />
                <span class="text-center">{{ videoObject.reason }}</span>
              </template>
            </p>
          </a-col>
        </a-row>
      </a-col>

      <a-col v-if="videoStatus == 'approved'" :md="{ span: 12 }" :lg="{ span: 11, offset: 1 }">
        <a-row type="flex" justify="center" class="qr-container">
          <a-col>
            <div>
              <span class="qr-code-label">{{ $t('label.qrCode') }}</span>
              <button class="download-qr-button icon-button" @click.prevent="onDownloadQRCode">
                <inline-svg :src="require('../../assets/images/download.svg')" width="15" height="12" />
              </button>
            </div>
          </a-col>
        </a-row>
        <a-row class="mt-2">
          <a-col>
            <qrcode-vue :value="pageUrl" :size="2000" render-as="svg" :margin="16" level="H" class="review-qr-code" />
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row v-if="videoStatus === 'approved'">
      <a-col>
        <a-card :title="'Get Your ' + (isIndividual ? 'Story' : 'Church') + ' Out There!'" class="style3 story-actions">
          <a-row class="mt-4 mb-4" type="flex" justify="center">
            <a-col>
              <a class="open-instruction-video" href="#" @click.prevent="e => openInstructionVideo(type)">
                <inline-svg :src="require('../../assets/images/video-capture.svg')" width="18" height="12" />
                <span>View instruction video again</span>
              </a>
            </a-col>
          </a-row>
          <a-row class="mt-4 mb-4" :gutter="24">
            <a-col :md="{ span: 6 }" class="text-right">
              <template v-if="isIndividual">
                <h5 v-if="theme == 'dark'">Your Jesus Story Link:</h5>
                <h5 v-else>Your {{ capitalize(type) }} Link:</h5>
              </template>
              <template v-else>
                <h5>Welcome Page:</h5>
              </template>
            </a-col>
            <a-col :md="{ span: 18 }" class="text-left">
              <span class="slug-value">
                <a :href="pageUrl" class="text-underline" target="_blank">{{ pageUrl }}</a>
                <a-button type="primary" class="tf-btn tf-btn-primary clipboard-btn" v-clipboard:copy="pageUrl" v-clipboard:success="clipboardSuccess">
                  <inline-svg :src="require('../../assets/images/clipboard.svg')" width="12" height="14" />
                </a-button>
              </span>
            </a-col>
          </a-row>
          <a-row class="mt-4 mb-4" :gutter="24">
            <a-col :md="{ span: 6 }" class="text-right">
              <h5>Social Media:</h5>
            </a-col>
            <a-col :sm="{ span: 16 }" :md="{ span: 10 }" class="share-wrapper text-left">
              <span :data-url="pageUrl" class="st-left sharethis-inline-share-buttons st-has-labels"></span>
            </a-col>
          </a-row>
          <a-row class="mt-4 mb-4" :gutter="24" v-if="type === 'welcome'">
            <a-col :md="{ span: 6 }" class="text-right">
              <h5>Church Profile Link:</h5>
            </a-col>
            <a-col :md="{ span: 18 }" class="text-left">
              <span class="slug-value">
                <a :href="churchUrl" class="text-underline" target="_blank">{{ churchUrl }}</a>
                <a-button type="primary" class="tf-btn tf-btn-primary clipboard-btn" v-clipboard:copy="churchUrl" v-clipboard:success="clipboardSuccess">
                  <inline-svg :src="require('../../assets/images/clipboard.svg')" width="12" height="14" />
                </a-button>
              </span>
            </a-col>
          </a-row>
          <a-row class="mt-4 mb-4" :gutter="24">
            <a-col :md="{ span: 6 }" class="text-right">
              <h5>Order Your Cards:</h5>
            </a-col>
            <a-col :md="{ span: 18 }" class="text-left">
              <a-button type="primary" @click="$router.push('/orderCards')" class="tf-btn tf-btn-primary btn-order-start">
                <span>Start Here</span>
              </a-button>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import initialSharethis from '@/utils/sharethis';
import { capitalize, convertVideoToEmbed } from '@/utils';
import Constants from '@/constants.js';
import { includes, isEmpty } from 'lodash';

import store from '@/store';
import UserService from '@/services/UserService';
import LocationService from '@/services/LocationService';

export default {
  components: {
    QrcodeVue,
  },
  props: {
    videoObject: {
      type: Object,
    },
    videoSlug: {
      type: String,
    },
    type: {
      type: String,
      default: 'welcome',
    },
    language: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      isShowClickLink: true,
      isConnecting: false,
      thumbnailVisible: true,
      churchList: [],
      selectedChurch: {},
      isViewExample: false,
      isConnectionSent: false,
      isConnectionVisible: false,
      isCreationSent: false,
      isSubmitFormVisible: false,
      isMultiAttempt: false,
      searchAttempt: false,
      isConnected: false,
      connectedChurchName: '',
      videoElement: null,
      canvasElement: null,
      canvasContext: null,
      canvasWidth: 0,
      canvasHeight: 0,
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'Action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      form: this.$form.createForm(this, { name: 'form' }),
    };
  },
  computed: {
    ...mapGetters(['theme']),
    ...mapState(['settings', 'user']),
    ...mapState({
      billingInfo: state => state.payment.billingInfo,
    }),
    reviewPlayerId() {
      // Ensure a unique jwplayer container id per component instance
      const slugPart = this.videoSlug ? this.videoSlug.replace(/[^a-zA-Z0-9_-]/g, '') : 'video';
      return `reviewVideo_${slugPart}_${this._uid}`;
    },
    pageUrl() {
      if (this.language === 'es') {
        return Constants.APP_URL + `/${this.language}/${this.type}/${this.videoSlug}`;
      }
      return Constants.APP_URL + `/${this.type}/${this.videoSlug}`;
    },
    churchUrl() {
      return 'https://www.truelife.org/church/' + this.videoObject.account_slug;
    },
    embedUrl() {
      return this.videoObject.video_type === 'embed' ? convertVideoToEmbed(this.videoObject.video_url) : null;
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    videoStatus() {
      const membership = this.$store.state.user.user.membership;
      // // https://developers.recurly.com/api-v2/v2.29/#tag/subscriptions

      if (this.isPastor && (!this.billingInfo || !membership || !['active', 'live'].includes(membership.state))) {
        return 'no_payment';
      }

      const status = this.videoObject.status;
      return ['notsure', 'created'].includes(status) ? 'review' : status;
    },
    videoStatusIcon() {
      const status = this.videoObject.status;
      switch (status) {
        case 'approved':
          return 'check-circle';
        case 'created':
        case 'no_payment':
        case 'notsure':
        case 'review':
          return 'exclamation-circle';
        case 'blocked':
          return 'warning';
        default:
          return 'exclamation-circle';
      }
    },
    isIndividual() {
      return includes(this.$store.state.user.user.role, 'individual');
    },
    connectedChurch() {
      return store.state.user.user.churchName || ['review', 'approved'].includes(store.state.user.user.churchStatus);
    },
  },
  methods: {
    ...mapActions({
      openInstructionVideo: 'openInstructionVideo',
    }),
    capitalize,
    clipboardSuccess() {
      this.$notification['success']({
        message: 'Copied to clipboard',
      });
    },
    onDownloadQRCode() {
      import('@/utils/fileSaver').then(file => {
        file.saveImage(document.querySelector('.review-qr-code svg'), this.videoSlug, 'svg');
      });
    },
    async onSearch(value) {
      this.churchList = await LocationService.getNearby(value);
      this.searchAttempt = true;
      this.isSubmitFormVisible = false;
    },
    fillForm(record) {
      this.searchAttempt = false;
      this.isSubmitFormVisible = true;
      const formData = {
        churchname: record.name,
        pastorname: record.pastor.name,
        pastoremail: record.pastor.email,
        churchnumber: record.pastor.phone,
      };
      this.form.setFieldsValue(formData);
      let elmnt = document.getElementById('churchConnectForm');
      elmnt.scrollIntoView({ behavior: 'smooth' });
    },
    async connectToChurch(record) {
      if (this.selectedChurch.name) {
        this.isMultiAttempt = true;
        return;
      }

      const { email } = store.state.user.user;
      /* eslint-disable camelcase */
      const { account_id, id } = record;

      const resp = await UserService.doUpdateUser({
        email,
        account_id,
        location_id: id,
        church_status: 'review',
      });
      store.dispatch('updateUser', {
        user: {
          ...store.state.user.user,
          churchStatus: resp.church_status,
          accountId: resp.account_id,
          churchName: record.name,
        },
      });
      this.isConnected = true;
      this.connectedChurchName = record.name;
      this.isSubmitFormVisible = false;
      this.selectedChurch = record;
      this.isConnectionSent = true;
    },
    async disconnectChurchConnection() {
      await UserService.doDisconnectChurchConnect({
        id: store.state.user.user.userId,
      });

      store.dispatch('updateUser', {
        user: {
          ...store.state.user.user,
          churchStatus: null,
          accountId: null,
          churchName: '',
        },
      });
      this.isConnected = false;
      this.connectedChurchName = '';
      this.selectedChurch = {};
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isConnecting = true;
            const resp = await UserService.doRequestChurchCreation(values);
            store.dispatch('updateUser', {
              user: {
                ...store.state.user.user,
                churchStatus: resp.data.status,
                accountId: resp.data.account_id,
                churchName: resp.data.church_name,
              },
            });
            this.isConnected = true;
            this.connectedChurchName = resp.data.church_name;
            this.isConnecting = false;
          } catch (e) {
            console.log(e);
          }

          this.isCreationSent = true;
          this.isSubmitFormVisible = false;
        }
      });
    },
    showChurchForm() {
      this.isShowClickLink = false;
      this.searchAttempt = false;
      this.isSubmitFormVisible = true;
      this.churchList = [];
    },
    drawCover(ctx, vid, w, h) {
      // Store variables
      const cw = w;
      const ch = h;
      const vw = vid.videoWidth;
      const vh = vid.videoHeight;

      // Bail when video is full width
      if (cw <= vid.clientWidth) return false;

      // Prevent black flash
      if (vid.currentTime === 0) return false;

      const r = 0;
      ctx.canvas.width = cw;
      ctx.canvas.height = ch;
      const rw = cw + 2 * r;
      const rh = (rw * vh) / vw;
      // Cover
      ctx.drawImage(vid, 0, 0, vw, vh, -r, (ch - rh) / 2, rw, rh);
      // Sretch
      // ctx.drawImage(vid, 0, 0, cw, ch);
    },
    draw(v, c, w, h) {
      if (v.paused || v.ended) return false;
      this.drawCover(c, v, w, h);
      window.requestAnimationFrame(() => {
        this.draw(v, c, w, h);
      });
    },
  },
  async mounted() {
    if (this.videoObject.video_type === 'external') {
      const player = window.jwplayer(this.reviewPlayerId).setup({
        file: this.videoObject.video_url,
        image: this.videoObject.video_thumbnail,
        primary: 'flash',
        type: 'mp4',
        autostart: false,
        repeat: false,
      });
      player.on('play', () => {
        this.slideVisible = false;

        this.draw(this.videoElement, this.canvasContext, this.canvasWidth, this.canvasHeight);
      });
      player.on('ready', () => {
        this.videoElement = this.$el.querySelector('video');
        this.canvasElement = document.createElement('canvas');
        this.videoElement.parentNode.insertBefore(this.canvasElement, this.videoElement);
        this.canvasContext = this.canvasElement.getContext('2d');
        this.canvasWidth = this.videoElement.parentNode.clientWidth;
        this.canvasHeight = this.videoElement.parentNode.clientHeight;
        console.log(this.canvasElement);
      });
    }

    // const { user } = store.state.user;
    this.isConnectionVisible = this.isIndividual;

    if (isEmpty(this.billingInfo)) {
      await this.$store.dispatch('fetchBillingInfo');
    }

    initialSharethis();
    this.isConnected = store.state.user.user.churchName || ['review', 'approved'].includes(store.state.user.user.churchStatus);
    this.connectedChurchName = store.state.user.user.churchName;
  },
};
</script>

<style lang="scss" scoped>
.left-col {
  text-align: left;
}

/deep/ .jw-state-idle .jw-controls {
  background: transparent !important;
}

.text-underline {
  text-decoration: underline;
  cursor: pointer;
}

.open-instruction-video {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  line-height: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #637381;
  text-decoration: none;
  margin-top: -20px;

  & span {
    margin-left: 8px;
  }
}

.status-tag {
  display: flex;
  font-size: 15px;
  font-weight: 600;

  & > img {
    margin-right: 8px;
  }

  &.created,
  &.notsure,
  &.review {
    color: #ff5349;
  }

  &.approved {
    color: #6aaa2c;
  }

  &.blocked {
    color: #e8544a;
  }
}

.slug-input-wrapper {
  padding-left: 16px;
  padding-right: 16px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  .slug-input-label {
    white-space: nowrap;
    flex: 0 0 auto;
    font-weight: 600;
  }

  & > .slug-value {
    margin-left: 8px;
    flex: 0 1 auto;
    word-break: break-all;

    & > a {
      color: #212b36;
      text-decoration: underline;
    }
  }
}

.video-container {
  &.under-review {
    max-width: 700px;
    margin: 0 auto;
  }
}

@media (max-width: 767px) {
  .slug-input-wrapper {
    flex-direction: column;
    align-items: start;

    & > .slug-value {
      margin-left: 0;
    }
  }

  .video-container {
    display: block !important;
  }

  .sharethis-inline-share-buttons {
    margin-left: 0 !important;
    .st-btn:first {
      margin-left: 0 !important;
    }
  }
  .btn-order-start {
    margin-left: 0 !important;
  }

  .clipboard-btn {
    display: none;
  }

  .text-right {
    text-align: left !important;
  }

  .review-qr-code {
    svg {
      max-width: 150px !important;
      max-height: 150px !important;
    }
  }

  .qr-container {
    margin-top: 1rem;
  }
}

.action-button {
  width: 120px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;

  &.long {
    width: 180px;
  }
}

.video-msg-review {
  font-family: Source Sans Pro;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0.05em;
  text-align: center;
  color: #000000;
}

.story-actions {
  margin-top: 3rem !important;
  border-radius: 15px !important;

  .ant-card-head {
    border-radius: 10px 10px 0 0 !important;
  }
}

.btn-order-start {
  margin-left: 4rem;
  width: 180px;
}

.sharethis-inline-share-buttons {
  margin-left: 4rem;
}

.clipboard-btn {
  line-height: 24px !important;
  height: 24px !important;
  width: 24px !important;
  padding: 0 !important;
  margin-left: 16px !important;
  border-radius: 5px !important;
}

h5 {
  font-weight: 600;
}

.player-wrapper {
  background-color: transparent;
  box-shadow: none;
  border-radius: 15px;
  overflow: hidden;
}

.responsive-embed {
  background-color: transparent;
  border-radius: 0px;
  box-shadow: none;
}

.qr-code-label {
  font-size: 16px;
}

.download-qr-button {
  margin-left: 8px;
}

.icon-button {
  padding: 0;
  line-height: 0;
  width: 22px;
  height: 22px;
  border-radius: 5px;
  border: none;
  background-color: #637381;
  color: white;
  outline: none;
}
</style>

<style lang="scss">
.content-item {
  .share-wrapper {
    #st-1 {
      display: flex;
      /* justify-content:; */

      .st-btn + .st-btn {
        margin-left: 4rem;
      }

      .st-btn {
        margin-right: 0;
        font-size: 13px;
        height: 32px;
        line-height: 32px;
        border-radius: 13px;

        & > img {
          width: 16px;
          height: 16px;
          top: 10px;
        }

        & > .st-label {
          min-width: unset;
        }

        &[data-network='facebook'] {
          order: 1;
          background-color: #1c84c6;
          min-width: 120px;
        }

        &[data-network='sharethis'] {
          order: 2;
          background-color: #1c84c6;
          min-width: unset;

          .st-label {
            display: none;
          }
        }

        &[data-network='email'] {
          order: 3;
          background-color: #8b8b8b;
          min-width: 120px;
          visibility: hidden;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .review-qr-code {
      svg {
        max-width: 150px !important;
        max-height: 150px !important;
      }
    }

    .story-actions {
      border-width: 0;

      .ant-card-head {
        background-color: transparent;
        color: #1c84c6 !important;
        text-decoration: underline;
        border-width: 0;

        .ant-card-head-title {
          font-size: 24px;
        }
      }
    }
  }

  .review-qr-code {
    position: relative;

    svg {
      max-width: 300px;
      max-height: 300px;
    }
  }

  .thumbnail-bg {
    display: flex;
    width: 100%;
    border: none;
    height: 0;
    padding-bottom: calc(56.25% + 30px);
    margin-top: -30px;
  }
  /* .thumbnail-bg::before {
    content: '';
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.25);
  } */
  .thumbnail-play {
    width: 88px;
    height: 100%;
    line-height: 88px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 999;
    margin: 0 auto;
  }

  .story-actions {
    .ant-card-head {
      border-radius: 10px 10px 0 0 !important;
    }
  }

  .connect-to-church {
    padding: 20px;
    .ant-btn {
      white-space: initial;
    }
  }

  .ant-card-head-title {
    text-align: center !important;
  }
  .jwplayer .jw-media video {
    width: auto !important;
  }
  .review-video {
    .jw-wrapper {
      .jw-media {
        canvas {
          filter: blur(15px);
        }
      }
    }
  }
  .review-video {
    background: black;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .ant-table-placeholder {
  white-space: break-spaces !important;
  color: #212b36 !important;
}

/deep/ .no-attempts .ant-table-placeholder {
  display: none !important;
}

/deep/ .ant-input-search .ant-input-search-button {
  background-color: #1c84c6 !important;
  border: none !important;
}
</style>
